var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWomanSitWithoutIcons = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 112,
  height: 113,
  viewBox: "0 0 112 113",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.8501 17.0249L29.8751 14.0249",
  stroke: "#AC41D8",
  strokeWidth: 5.4123,
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.8369 4.03779L33.0369 0.862793L35.0131 0.987278L34.8131 4.16228L32.8369 4.03779Z",
  fill: "#AC41D8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3476 5.65845L26.8726 2.83345L28.6278 1.91699L30.1028 4.74199L28.3476 5.65845Z",
  fill: "#AC41D8"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.6767 11.1193L23.5517 11.7693L23.1484 9.83066L26.2734 9.18066L26.6767 11.1193Z",
  fill: "#AC41D8"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M0.125 19.6003L9.525 91.2503C10.05 97.4503 13.925 101.3 20.35 101.875L94.725 102.625C101.15 103.2 106.8 99.3753 107.275 94.1003L111.6 39.8503C112.075 34.5753 107.2 29.8003 100.775 29.2253L12.675 11.0753C6.25 10.5003 0.6 14.3253 0.125 19.6003Z",
  fill: "url(#paint0_linear_20693_17805)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.3502 40.7002L20.3002 61.2252L35.2752 56.5252L42.2002 73.3502L13.3502 77.6252C8.77521 78.7752 4.12521 75.9752 2.97521 71.4002C2.42521 69.1752 2.77521 66.8252 3.97521 64.8502L24.1752 31.8252C24.1252 24.5502 27.1002 17.6002 30.0252 10.9502C30.1752 10.6002 30.3752 10.2252 30.8002 10.2502C31.1752 10.2752 31.4752 10.5252 31.5752 10.8752C32.2752 12.9502 31.6752 15.2502 31.1252 17.2752C30.4752 19.4252 30.4252 21.7252 30.9502 23.9252C31.4752 26.2752 32.2002 28.6752 31.8502 31.0502C32.8502 28.9752 33.7002 26.0502 35.3252 24.4002C35.5002 24.2252 35.7502 24.0502 36.0252 24.1752C36.3002 24.3252 36.4502 24.6002 36.4252 24.9002C36.3502 26.0002 35.9252 27.0252 35.6502 28.1002C34.9502 30.7502 35.2752 33.5002 34.2502 36.0752C33.2502 38.5502 31.3502 40.5502 28.9252 41.6502L30.3502 40.7002Z",
  fill: "#8D5524"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M65.2001 50.0503C62.0251 47.8003 58.0501 47.0253 54.2751 47.9253L27.9751 53.6503L34.0751 68.6503C34.9251 67.4503 39.3251 64.7503 40.5251 63.9003C46.9501 59.3253 49.3001 54.0753 56.5501 50.9253C59.2751 49.7503 62.3001 48.8003 65.2001 50.0503Z",
  fill: "url(#paint1_linear_20693_17805)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M49.9499 39.4248L50.3499 39.3498C50.8499 41.5498 51.2499 43.7498 51.5749 45.9998C51.6499 46.6748 51.7749 47.3248 51.9999 47.9498C52.5249 49.2748 53.5749 49.4498 54.7749 49.8748C55.8249 50.2498 56.8749 50.5998 57.9499 50.9248C60.3249 51.6748 62.7499 52.3998 65.1499 53.0748C67.3999 53.7248 69.6749 54.3498 71.9249 54.9748C72.8499 54.4998 73.2999 53.4248 72.9999 52.4498C71.9499 48.8498 66.2999 30.9248 66.2249 27.9998C66.1749 25.9748 66.3749 23.9498 66.1499 21.9498C65.5749 16.7248 61.8999 11.9998 56.9999 10.0498C51.1499 7.74982 43.4999 9.47482 39.9499 14.8498C38.7749 16.6248 39.0499 17.3748 38.3749 19.3748C37.8749 21.6248 37.3749 25.1248 37.4999 28.7748C37.5749 30.2998 39.6249 37.0748 40.5499 38.7998C41.8749 41.2748 45.7999 40.2748 47.9999 39.8748L49.9499 39.4248Z",
  fill: "#8D5524"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M50.3502 39.3501H50.3252L50.9752 42.9501L51.0752 42.8501C50.8502 41.6751 50.6252 40.5251 50.3502 39.3501Z",
  fill: "#E5BC74"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M55.9498 37.6499L50.2998 39.3249V39.3749H50.3248C50.5998 40.5499 50.8248 41.6999 51.0498 42.8749L55.9498 37.6499Z",
  fill: "#4C1D05"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M83.0001 97.0999L78.1501 47.4749C77.9251 44.6749 75.6001 42.5249 72.8001 42.5249C68.4251 42.8249 64.0501 43.2249 59.7001 43.5999C55.9251 43.9499 51.7001 43.8499 48.0251 44.7749C44.9001 45.5499 43.1001 48.1999 41.6751 50.8749C37.9501 57.8249 34.8001 65.1249 32.6001 72.6749C31.8501 75.2999 31.3251 78.5249 33.2751 80.4749C34.6001 81.7999 36.6251 82.0499 38.4751 82.2249L37.8251 104.75L74.0501 110.975C74.0751 110.975 84.0001 113.5 83.0001 97.0999Z",
  fill: "#00D38D"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M69.9998 75.8252L69.5998 97.7002C69.5748 98.7752 68.6998 99.6502 67.5998 99.6252H67.5248L48.2998 98.5002L49.8998 108.625L75.9998 112.025C80.5748 112.625 84.7998 109.45 85.4998 104.875C85.6248 104.05 85.7498 103.2 85.8748 102.325C87.8248 89.1002 88.7248 76.9752 88.6248 76.8252L69.9998 75.8252Z",
  fill: "#8D5524"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M90.8749 81.3002L65.1249 77.3252L64.8499 54.0752C64.6999 46.5502 70.6749 40.3002 78.1999 40.1502C85.7249 40.0002 91.9749 45.9752 92.1249 53.5002C92.1249 53.5752 92.1249 53.6502 92.1249 53.7252C92.1249 53.8502 92.1249 54.0002 92.1249 54.1252L90.8749 81.3002Z",
  fill: "#00D38D"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M78.5 40.2749C70.975 40.2999 64.875 46.3999 64.875 53.8999V54.0749L65.15 77.3249L90.9 81.2999L92.15 54.1749V53.9499C92.15 46.3999 86.05 40.2999 78.5 40.2749Z",
  fill: "url(#paint2_linear_20693_17805)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M104.625 49.4999C104.525 42.0249 99.625 36.6249 92.775 34.1499C87.4 32.1999 85.7 31.1749 81.125 27.3498C76.85 23.7748 75.95 17.5749 72.675 13.0498C68.325 7.07485 60.375 4.82485 52.975 4.62485C49 4.52485 36.85 6.17485 36.3 11.3749C35.775 16.3749 40.3 17.7498 44.45 17.9248C46.95 18.0248 49.3 17.5749 51.8 17.3998C51.9 18.4248 51.925 24.2998 53.05 24.0498C53.825 23.8748 54.3 22.1998 54.75 21.6498C56.775 19.1998 59.775 20.6248 59.7 23.6999C59.675 24.8748 59.45 26.0749 58.7 26.9998C58.325 27.4248 57.9 27.7999 57.375 28.0749C56.5 28.5749 56.375 28.3748 56.2 29.3249C54.8 36.1498 60.075 41.1249 64.15 45.6999C64.7 46.2499 65.15 46.8749 65.55 47.5249C66.15 48.6249 66.3 49.8999 66.575 51.1249C67.95 57.0499 72.775 61.8248 78.4 64.0748C81.8 65.4748 85.5 65.9249 89.125 65.4249C96.8 64.2749 104.75 57.7249 104.625 49.4999Z",
  fill: "black"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9252 99.3752C51.2002 97.5752 48.8002 96.5752 46.4002 95.9252C45.1752 95.6002 43.9002 95.3252 42.6252 95.4752C41.3502 95.6252 40.2252 96.1502 39.1002 96.7002C37.2252 97.6502 35.4252 98.7002 33.6002 99.7502L26.4252 103.9C25.5502 104.4 25.2752 105.5 25.7502 106.35C25.9752 106.75 26.3502 107.05 26.7752 107.175C27.4752 107.375 28.2252 107.475 28.9502 107.425C30.8252 107.35 32.6002 106.675 34.4002 106.15C36.1752 105.625 38.1252 105.225 39.9252 105.775C40.9752 106.075 41.9252 106.7 42.8752 107.275C44.0252 108.025 45.3002 108.575 46.6502 108.925C48.0002 109.225 49.4502 109.175 50.6752 108.525",
  fill: "#8D5524"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M50.5752 22.7749C50.5752 23.3249 50.1252 23.7749 49.5752 23.7749C49.0252 23.7749 48.5752 23.3249 48.5752 22.7749C48.5752 22.2249 49.0252 21.7749 49.5752 21.7749C50.1252 21.7499 50.5752 22.1999 50.5752 22.7749Z",
  fill: "#191919"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3252 22.7749C41.3252 23.3249 40.8752 23.7749 40.3252 23.7749C39.7752 23.7749 39.3252 23.3249 39.3252 22.7749C39.3252 22.2249 39.7752 21.7749 40.3252 21.7749C40.8752 21.7499 41.3252 22.1999 41.3252 22.7749Z",
  fill: "#191919"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6502 21.5C44.4752 21.5 44.2752 21.6 44.2252 21.825C43.6502 23.75 43.0002 25.675 42.5002 27.625C42.0252 29.5 43.4252 29.7 44.8252 29.7C45.2252 29.7 45.6252 29.675 46.0002 29.675C46.6002 29.675 46.6002 28.75 46.0002 28.75C45.6252 28.75 44.9502 28.85 44.4002 28.85C44.1252 28.85 43.8752 28.825 43.7252 28.75C42.9502 28.35 43.6002 27.175 43.7752 26.575C44.2252 25.075 44.6752 23.55 45.1252 22.05C45.2002 21.725 44.9252 21.5 44.6502 21.5Z",
  fill: "#4C1D05"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M43.875 31.875H43.2C43.025 31.875 42.875 32.025 42.875 32.2C42.875 32.375 43.125 32.375 43.125 32.375C43.875 32.875 43.875 33.625 43.875 34.875C43.875 36.375 42.875 36.125 43.5 36.575C43.625 36.6 43.75 36.625 43.875 36.625C44.85 36.625 46.2 35.925 46.375 34.625C46.625 32.875 44.85 31.875 43.875 31.875Z",
  fill: "#4C1D05"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20693_17805",
  x1: 12.298,
  y1: 98.2418,
  x2: 93.2648,
  y2: 17.275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E97903"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0739316,
  stopColor: "#EC8709"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2075,
  stopColor: "#EF9910"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3662,
  stopColor: "#F2A616"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5723,
  stopColor: "#F4AE19"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4B01A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20693_17805",
  x1: 28.7235,
  y1: 74.2583,
  x2: 54.5338,
  y2: 41.7399,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AF4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00D38D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_20693_17805",
  x1: 64.678,
  y1: 59.1777,
  x2: 92.8401,
  y2: 61.5327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AF4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00D38D"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWomanSitWithoutIcons);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/woman_sit_without_icons.749cace827df3609e834ad579715c737.svg";